import React, { createContext, useMemo, useReducer } from 'react';
import { Action, TChildren } from '@models/common';
import { extend } from '@utils/common';

type Props = {
  children: TChildren;
};

type State = {
  parentUrl: string;
};

type ThemeContextValue = {
  themeState: State;
  themeDispatch: React.Dispatch<Action<ActionType>>;
};

enum ActionType {
  SET_PARENT_URL = 'SET_PARENT_URL',
}

const initialState: State = {
  parentUrl: window.location.origin,
  // window.location !== window.parent.location ? document.referrer : '',
};

export const ActionCreator = {
  setParentUrl: (url: string) => ({
    type: ActionType.SET_PARENT_URL,
    payload: url,
  }),
};

const reducer = (state: State, action: Action<ActionType>) => {
  switch (action.type) {
    case ActionType.SET_PARENT_URL:
      return extend(state, {
        parentUrl: action.payload,
      });
    default:
      return state;
  }
};

export const ThemeContext = createContext<ThemeContextValue>({
  themeState: initialState,
  themeDispatch: () => {},
});

const ThemeProvider: React.FC<Props> = ({ children }) => {
  const [themeState, themeDispatch] = useReducer(reducer, initialState);
  const value = useMemo(() => ({ themeState, themeDispatch }), [themeState]);

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};

export default ThemeProvider;
